import {useState} from "react";
import {Download, PhoneCall} from "lucide-react";
import {FormModal} from "@/components/UI";
import {apiPost} from "@/lib/api";

export const SAMPLE_REPORT_URL = "/sample-purchase-decision-report.pdf";

export const REPORT_COVERS = ["Material quality", "Workmanship", "Durability", "Value for money & ROI", "Verified reviews", "What Reddit & Quora say", "Price benchmarks", "Risks & red flags"];

export function SampleReportLink({testId = "download-sample-report"}) {
  return (
    <a data-testid={testId} className="outline-button sm sample-link" href={SAMPLE_REPORT_URL} download target="_blank" rel="noreferrer">
      <Download size={14}/> Download sample report
    </a>
  );
}

export default function PurchaseReportModal({close, notify, requireAuth, product = ""}) {
  const [f, setF] = useState({product_name: product, product_link: "", budget: "", concerns: "", phone: "", callback_time: ""});
  const ch = e => setF({...f, [e.target.name]: e.target.value});
  const submit = (e) => {
    e.preventDefault();
    requireAuth(async () => {
      try {
        await apiPost("/purchase-reports", f);
        notify("Report requested — we'll call you back with discounted pricing");
        close();
      } catch { notify("Please check the form and try again"); }
    });
  };
  return (
    <FormModal title="Buy with confidence." eyebrow="PURCHASE DECISION REPORT" close={close} width={620} testId="pdr-modal">
      <p className="modal-sub">Before you spend, we research the product for you. For discounted pricing, fill the form below and we&rsquo;ll arrange a call back.</p>
      <div className="report-covers">{REPORT_COVERS.map(c => <span key={c}>{c}</span>)}</div>
      <SampleReportLink testId="pdr-modal-sample"/>
      <form onSubmit={submit}>
        <label>Product you&rsquo;re considering
          <input data-testid="pdr-product" required name="product_name" value={f.product_name} onChange={ch} placeholder="e.g. Patola silk saree from Patan"/>
        </label>
        <label>Link (optional)
          <input data-testid="pdr-link" name="product_link" value={f.product_link} onChange={ch} placeholder="Paste a product or seller link"/>
        </label>
        <label>What worries you about it? (optional)
          <textarea data-testid="pdr-concerns" name="concerns" value={f.concerns} onChange={ch} placeholder="Authenticity, durability, is it worth the price..."/>
        </label>
        <div className="form-row">
          <label>Phone / WhatsApp
            <input data-testid="pdr-phone" required minLength={6} name="phone" value={f.phone} onChange={ch} placeholder="+44 7..."/>
          </label>
          <label>Best time to call
            <input data-testid="pdr-callback" name="callback_time" value={f.callback_time} onChange={ch} placeholder="Weekdays after 6pm UK"/>
          </label>
        </div>
        <button data-testid="pdr-submit" className="coral-button full" type="submit"><PhoneCall size={15}/> Arrange a call back</button>
      </form>
    </FormModal>
  );
}
